import BlockWrapper from "blocks/components/BlockWrapper";
import { usePageContext } from "lib/context/page-context";
import { useTheme } from "lib/theme";
import { ConnectedEditorKanban } from "./components/ConnectedEditorKanban";
import { ConnectedLiveKanban } from "./components/ConnectedLiveKanban";
import type { KanbanBlock as KanbanBlockType } from "../types";
import type { BlockProps } from "blocks/v2/__shared__/types";
import { Suspense } from "react";
import KanbanSkeleton from "./components/Skeleton";

export const KanbanBlock = (props: BlockProps<KanbanBlockType>) => {
  const { isEditing } = usePageContext();
  const { stateId, config } = props.block;
  const theme = useTheme();

  const ConnectedKanban = isEditing
    ? ConnectedEditorKanban
    : ConnectedLiveKanban;

  if (!isEditing && (!stateId || !config.tableId)) return null;

  return (
    <BlockWrapper
      blockId={props.blockId}
      block={props.block}
      maxWidth={
        config.style?.width
          ? theme.app.width[config.style?.width]
          : theme.app.width.full
      }
      alignment={config.style?.alignment}
    >
      <Suspense
        fallback={
          <KanbanSkeleton block={props.block} blockId={props.blockId} />
        }
      >
        <ConnectedKanban block={props.block} blockId={props.blockId} />
      </Suspense>
    </BlockWrapper>
  );
};
